import { listServices} from 'services';
import { loader } from '../helpers';
import { listConstants } from '../constants';
import lodash from 'lodash';

export const listActions = {
    getCategoryList,
}

function getCategoryList(type, queryStringParams){
    return dispatch => {
        listServices.getCategoryList(type, queryStringParams)
            .then(
                response => {
                    if (response.status) {
                        // dispatch(success(response.data))
                        const categoryList = lodash.has(response.data,'data') ? lodash.get(response.data,'data') : []
                        dispatch(success(categoryList))
                    }
                },
                error => {
                    return [];
                }
            ).then(() => {
                loader(dispatch, false)
            })
    };
    function success(data) { return { type: listConstants.GET_CAMPAIGN_CATEGORY_LIST, data }}
}
